import { render } from "./AllRecommandations.vue?vue&type=template&id=37a97cd2&scoped=true"
import script from "./AllRecommandations.vue?vue&type=script&lang=js"
export * from "./AllRecommandations.vue?vue&type=script&lang=js"

import "./AllRecommandations.vue?vue&type=style&index=0&id=37a97cd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a97cd2"]])

export default __exports__